/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import * as serviceWorker from './serviceWorker';

// local imports
import AuthProvider from './contexts/AuthContext';
import ThemeProvider from './contexts/ThemeContext';
import PsychometricProvider from './contexts/PsychometricContext';
ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <PsychometricProvider>
        <App />
        </PsychometricProvider>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
// serviceWorker.register();